// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: window.location.origin + '/api',
  azureEntra: {
    tenantId: '3081b6eb-204d-47f9-95d2-8a5994eb97ec',
    clientId: '513dc8f9-1fb3-40b5-b87f-c557e9817485',
    redirectUri: window.location.origin + '/admin',
    storeAuthStateInCookie: true,
    storage: 'localStorage'
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
